// Dev-mode stub for usePdfGenerator.
//
// The real composable (./usePdfGenerator.ts) statically imports jspdf +
// handlebars. With those in the watcher's module graph, vite's incremental
// rebuild deadlocks on Windows. A vite resolve.alias swaps this file in for
// `@/composables/usePdfGenerator` during `mode === 'development'`, keeping the
// heavy deps out of the dev bundle entirely — this covers every consumer of the
// composable (the PdfGenerator "Print Results" button and the Quote Illustration
// on the confirmation page). Production builds use the real composable unchanged.

const disabledInDev = (): void => {
  alert(
    'PDF generation is disabled in development mode to avoid a Windows hot-reload hang ' +
    '(jspdf + handlebars). Run `npm run build` to test PDF output, or temporarily edit ' +
    'the dev alias in vite.config.ts (remember to revert before committing).'
  );
};

export function usePdfGenerator()
{
  const generate = async (
    _templateSource: string,
    _data: Record<string, any>,
    _filename?: string,
  ): Promise<void> =>
  {
    disabledInDev();
  };

  const generateInBackgroundTab = async (
    _templateSource: string,
    _data: Record<string, any>,
    _filename?: string,
    _renderHtml?: boolean,
  ): Promise<void> =>
  {
    disabledInDev();
  };

  return { generate, generateInBackgroundTab };
}
